<template>
  <PartyDetails kind="customer" />
</template>

<script>
import PartyDetails from "@/components/party/PartyDetails.vue";

export default {
  name: "customer-details",
  components: { PartyDetails },
};
</script>
